import PropTypes from 'prop-types';
import Header from '@layout/SimpleLayout/Header';
import NewFooter from './Footer';

const SimpleLayoutWithFooter = ({
  children,
  className,
  showFooter,
  showLogin,
  layoutOptions = {}
}) => {
  return (
    <>
      <Header
        showLogin={layoutOptions.showLogin ?? showLogin}
        className={className}
        hideHeaderShadow={layoutOptions.hideHeaderShadow}
      />
      {children}
      {showFooter && <NewFooter />}
    </>
  );
};

SimpleLayoutWithFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string,
  showFooter: PropTypes.bool,
  showLogin: PropTypes.bool
};

SimpleLayoutWithFooter.defaultProps = {
  className: '',
  showFooter: true,
  showLogin: false
};

export default SimpleLayoutWithFooter;
